<script>
    import { createEventDispatcher } from 'svelte';

    // Declare the dispatcher
    const dispatch = createEventDispatcher();

    //PROPS
    export let maleLabel = 'male';
    export let femaleLabel = 'female';
    export let value;
    export let error = false;

    //METHODS
    const changeGender = (value) => {
        dispatch('gender', value);
    };
</script>

<!-- ======================== HTML TEMPLATE ================================= -->
<div class="app-msi_flex-column app-msi_align-items-center">
    <div class="app-msi_form-row">
        <div class={error ? 'emi-has-error app-msi_radio-btn-group' : 'app-msi_radio-btn-group'}>
            <div class="app-msi_radio">
                <input
                    type="radio"
                    name="gender"
                    id="male"
                    value="male"
                    checked={value === 'male'}
                    on:change={() => changeGender('male')}
                />
                <label for="male">{maleLabel}</label>
            </div>
            <div class="app-msi_radio">
                <input
                    type="radio"
                    name="gender"
                    id="female"
                    value="female"
                    checked={value === 'female'}
                    on:change={() => changeGender('female')}
                />
                <label for="female">{femaleLabel}</label>
            </div>
        </div>
    </div>
</div>
